module.exports = __webpack_public_path__ + "static/media/occupiers-at-ansty-park.22991eb9.png";